/* TOTOKA Bundles: one-time reveals, no scroll loop or product parallax. */
(() => {
  'use strict';
  const key = '__totokaBundlesValueSystem';
  if (window[key]) { window[key].mount(document); return; }
  const selector = '[data-tbv-root]';
  const instances = new WeakMap();
  const roots = (scope) => scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
  class BundleSection {
    constructor(root) {
      this.root = root;
      this.targets = [...new Set(root.querySelectorAll('[data-tbv-reveal], .tbv-bundle, [data-tbv-saving]'))];
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onPreference = () => this.showAll();
      this.preference.addEventListener('change', this.onPreference);
      root.style.setProperty('--tbv-progress', '1');
      if (this.preference.matches || !('IntersectionObserver' in window)) { this.showAll(); return; }
      try {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            if (!isIntersecting) return;
            this.reveal(target);
          });
        }, { threshold: 0, rootMargin: '0px 0px 64px 0px' });
        this.targets.forEach(target => this.observer.observe(target));
        root.classList.add('is-motion-ready');
      } catch (_) { this.showAll(); }
    }
    reveal(target) {
      target.classList.add('is-visible');
      this.observer?.unobserve(target);
      target.querySelectorAll('[data-tbv-saving]').forEach(node => {
        node.classList.add('is-visible');
        this.observer?.unobserve(node);
      });
    }
    showAll() {
      this.observer?.disconnect();
      this.root.classList.remove('is-motion-ready');
      this.targets.forEach(target => target.classList.add('is-visible'));
    }
    destroy() {
      this.showAll();
      this.preference.removeEventListener('change', this.onPreference);
      this.root.style.removeProperty('--tbv-progress');
    }
  }
  const mount = (scope = document) => roots(scope).forEach(root => {
    if (!instances.has(root)) instances.set(root, new BundleSection(root));
  });
  const unmount = scope => roots(scope).forEach(root => {
    instances.get(root)?.destroy();
    instances.delete(root);
  });
  window[key] = { mount, unmount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest?.(selector);
    if (root) instances.get(root)?.showAll();
  });
})();
